import styled from 'styled-components';
import { useEffect, useState } from 'react';
import { InfoTab } from './components/main/InfoTab';
import { CommonModal } from './components/modal/CommonModal';
import { useApiHook } from './hook/useApiHook';
import { EndDateModal } from './components/modal/EndDateModal';
import { closeWebview, isPc } from './utils';
import { MAIN_TAB_STATUS, SUB_TAB_STATUS } from './types/type';
import { RewardInfo } from './components/main/reward/RewardInfo';
import { TestBox } from './components/TestBox';
import { Header } from './components/main/Header';
import { ProgressInfo } from './components/main/progress/ProgressInfo';
import { MainEvent } from './components/main/main-event/MainEvent';
import { ParticipationInfo } from './components/main/participate/ParticipationInfo';
import { ImageUtils } from './utils/ImageUtils';
import { Flare } from './components/main/Flare';

export const App = () => {
  const [mainTab, setMainTab] = useState<MAIN_TAB_STATUS>(MAIN_TAB_STATUS.REWARD);
  const [subTab, setSubTab] = useState<SUB_TAB_STATUS>(SUB_TAB_STATUS.ONLINE);
  const { getEventInfo } = useApiHook();
  const isMobile = !isPc();

  useEffect(() => {
    if (isMobile) {
      getEventInfo();
    }
  }, [getEventInfo, isMobile]);

  const goMainEventTab = () => {
    setMainTab(MAIN_TAB_STATUS.MAIN_EVENT);
  };

  const goOfflineTab = () => {
    setMainTab(MAIN_TAB_STATUS.PARTICIPATE);
    setTimeout(() => {
      setSubTab(SUB_TAB_STATUS.OFFLINE);
    }, 0);
  };

  const goOnlineTab = () => {
    setMainTab(MAIN_TAB_STATUS.PARTICIPATE);
    setSubTab(SUB_TAB_STATUS.ONLINE);
  };

  return (
    <Wrap>
      <Bg />
      <TestBox />
      <HeaderContainer>
        <Flare />
        <HeaderInner>
          {isMobile && <CloseButton src={ImageUtils.CloseIcon} onClick={closeWebview} />}
          <Header />
          <InfoTab mainTab={mainTab} setMainTab={setMainTab} />
        </HeaderInner>
      </HeaderContainer>
      <BottomContainer>
        <Inner>
          {mainTab === MAIN_TAB_STATUS.REWARD && <RewardInfo />}
          {mainTab === MAIN_TAB_STATUS.PARTICIPATE && (
            <ParticipationInfo subTab={subTab} setSubTab={setSubTab} />
          )}
          {mainTab === MAIN_TAB_STATUS.PROGRESS && (
            <ProgressInfo
              goMainEventTab={goMainEventTab}
              goOfflineTab={goOfflineTab}
              goOnlineTab={goOnlineTab}
            />
          )}
          {mainTab === MAIN_TAB_STATUS.MAIN_EVENT && <MainEvent goOfflineTab={goOfflineTab} />}
        </Inner>
      </BottomContainer>
      <CommonModal />
      <EndDateModal />
    </Wrap>
  );
};

const Wrap = styled.div`
  width: 100%;
  position: relative;
  z-index: 2;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const HeaderContainer = styled.div`
  position: relative;
  width: 100%;
`;

const HeaderInner = styled.div`
  max-width: 820px;
  margin: 0 auto;
`;

const CloseButton = styled.img`
  width: 20px;
  height: 20px;
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 10;
`;

const BottomContainer = styled.div`
  position: relative;
  background: #302e2d;
  display: flex;
  flex: 1;
`;

const Inner = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
`;

const Bg = styled.div`
  position: fixed;
  height: 100%;
  left: 0;
  top: 0;
  width: 100%;
  background: linear-gradient(
    164.47deg,
    #be2650 4.5%,
    #661128 24.9%,
    #3f0e1e 62.84%,
    #261605 100.33%
  );
  z-index: 0;
`;
